import { render, staticRenderFns } from "./alterationdept.vue?vue&type=template&id=606c831d&scoped=true"
import script from "./alterationdept.vue?vue&type=script&lang=js"
export * from "./alterationdept.vue?vue&type=script&lang=js"
import style0 from "./alterationdept.vue?vue&type=style&index=0&id=606c831d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606c831d",
  null
  
)

export default component.exports